// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"CheckboxComponent_checkboxLabel__5XsUb","checkbox":"CheckboxComponent_checkbox__n5whZ","label":"CheckboxComponent_label__YTPHq"};